/**
 * Renders a paginated row count that the server may have capped.
 *
 * The Contacts and Companies count queries stop scanning at a cap (10,000) for performance, so
 * `meta.itemCount` is a floor rather than a total whenever `meta.isCapped` is set. Showing it bare
 * tells the user their dataset *is* that size — which is how a customer with 42,229 contacts came
 * to report that "I can only export the first 10,000 rows" (PREC-3953).
 *
 * Returns an empty string for a missing count so callers can render nothing.
 */
export function formatCappedCount(count?: number | null, isCapped?: boolean): string {
	if (count === undefined || count === null) {
		return "";
	}

	const formatted = count.toLocaleString("en-US");

	return isCapped ? `${formatted}+` : formatted;
}
